import EmptyComponent from './EmptyComponent';
import Code from './Code';
import Content1 from './Content1.jsx';
import Content2 from './Content2.jsx';
import Content3 from './contents/Content3.jsx';
import Content4 from './contents/Content4.jsx';
import Content5 from './contents/Content5.jsx';
import Content6 from './contents/Content6.jsx';
import Content7 from './contents/Content7.jsx';
import Content8 from './contents/Content8.jsx';
import Content9 from './contents/Content9.jsx';
import Content10 from './contents/Content10.jsx';
import Content11 from './contents/Content11.jsx';
import Content12 from './contents/Content12.jsx';
import Content13 from './contents/Content13.jsx';
// import Content11 from './contents/Content11.jsx';
// import Content2 from './Content2.jsx';
import Features from './Features.jsx';
import SpaceSection from './SpaceSection.jsx';
import Testimonials from './Testimonials.jsx';
import VideoImage from './VideoImage.jsx';
import Faqs from './Faqs.jsx';
import Map from './Map';
import Form from './Form.jsx';

import { About as About1, Services as Services1, Courses as Courses1, Teams as Teams1 } from 'src/screens/WhiteLabels/Templates/Template1/screens/Home';
import { About as About2, Services as Services2, Courses as Courses2, Teams as Teams2 } from 'src/screens/WhiteLabels/Templates/Template2/screens/Home';
import { About as About3, 
    Services as Services3, 
    Courses as Courses3,
     Teams as Teams3,
    HomeHeader as HomeHeader1, 
    HomeHeader as HomeHeader2,
    HomeHeader as HomeHeader3,
    HomeHeader as HomeHeader4 
} from 'src/screens/WhiteLabels/Templates/Template3/screens/Home';
import { About as About4, Services as Services4, Courses as Courses4, Teams as Teams4 } from 'src/screens/WhiteLabels/Templates/Template4/screens/Home';

import { SimpleHeader as SimpleHeader1 } from 'src/screens/WhiteLabels/Templates/Template1/screens/Contact';
import { SimpleHeader as SimpleHeader2 } from 'src/screens/WhiteLabels/Templates/Template2/screens/Contact';
import { SimpleHeader as SimpleHeader3 } from 'src/screens/WhiteLabels/Templates/Template3/screens/Contact';
import { SimpleHeader as SimpleHeader4 } from 'src/screens/WhiteLabels/Templates/Template4/screens/Contact';

// import {Services as Services3} from './services/Services1';
import {Courses as Courses5} from './courses/Course1';
import {Courses as Courses6} from './courses/Course2';
import {Courses as Courses7} from './courses/Course3';
import {Courses as Courses8} from './courses/Course4';
import {Courses as Courses9} from './courses/Course5';
import {Courses as Courses10} from './courses/Course6';
import {Courses as Courses11} from './courses/Course7';

import {Services as Services5} from './services/Services1';
import {Services as Services6} from './services/Services2';
import {Services as Services7} from './services/Services3';
import {Services as Services8} from './services/Services4';
import {Services as Services9} from './services/Services5';
import {Services as Services10} from './services/Services6';
// import {Services as Services11} from './services/Services7';

const Components = {
    'Code': Code,
    'Map': Map,
    'Content1': Content1,
    'Content2': Content2,
    'Content3': Content3,
    'Content4': Content4,
    'Content5': Content5,
    'Content6': Content6,
    'Content7': Content7,
    'Content8': Content8,
    'Content9': Content9, 
    'Content10': Content10,
    'Content11': Content11,
    'Content12': Content12,
    'Content13': Content13,
    'Features': Features,
    'SpaceSection': SpaceSection,
    'Testimonials': Testimonials,
    'VideoImage': VideoImage,
    'Faqs': Faqs,
    'Form': Form,
    'EmptyComponent': EmptyComponent,
    'About1': About1,
    'About2': About2,
    'About3': About3,
    'About4': About4,
    'Services1': Services1,
    'Services2': Services2,
    'Services3': Services3,
    'Services4': Services4,
    'Services5': Services5,
    'Services6': Services6,
    'Services7': Services7,
    'Services8': Services8,
    'Services9': Services9,
    'Services10': Services10,
    'Courses1': Courses1,
    'Courses2': Courses2,
    'Courses3': Courses3,
    'Courses4': Courses4,
    'Courses5': Courses5,
    'Courses6': Courses6,
    'Courses7': Courses7,
    'Courses8': Courses8,
    'Courses9': Courses9,
    'Courses10': Courses10,
    'Courses11': Courses11,
    'Teams1': Teams1,
    'Teams2': Teams2,
    'Teams3': Teams3,
    'Teams4': Teams4,
    'HomeHeader1': HomeHeader1,
    'HomeHeader2': HomeHeader1,
    'HomeHeader3': HomeHeader1,
    'HomeHeader4': HomeHeader1,
    'SimpleHeader1': SimpleHeader1,
    'SimpleHeader2': SimpleHeader2,
    'SimpleHeader3': SimpleHeader3,
    'SimpleHeader4': SimpleHeader4,
};

export { 
    Code,
    Map,
    Testimonials,
    VideoImage,
    Faqs,
    Form,
    Content1,
    Content2,
    Content3,
    Content4,
    Content5,
    Content6,
    Content7,
    Content8,
    Content9,
    Content10,
    Content11,
    Content12,
    Content13,
    Features,
    SpaceSection,
    EmptyComponent,
    About1,
    About2,
    About3,
    About4,
    Services1,
    Services2,
    Services3,
    Services4,
    Services5,
    Services6,
    Services7,
    Services8,
    Services9,
    Services10,
    Courses1,
    Courses2,
    Courses3,
    Courses4,
    Courses5,
    Courses6,
    Courses7,
    Courses8,
    Courses9,
    Courses10,
    Courses11,
    Teams1,
    Teams2,
    Teams3,
    Teams4,
    HomeHeader1,
    HomeHeader2,
    HomeHeader3,
    HomeHeader4,
    SimpleHeader1,
    SimpleHeader2,
    SimpleHeader3,
    SimpleHeader4,
};

export default Components;